<template>
  <div class="modal" :class="modal.class" v-if="modal.status" @click="closeModal()">
    <div @click.stop="">
      <component :is="modal.component"></component>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Clear from '@/components/modal/Clear'
import Conflicts from '@/components/modal/Conflicts'
import Copy from '@/components/modal/Copy'
import Delete from '@/components/modal/Delete'
import Details from '@/components/modal/Details'
import Manager from '@/components/modal/Manager'
import MassDelete from '@/components/modal/MassDelete'
import Upload from '@/components/modal/Upload'

export default {
  components: {
    Clear,
    Conflicts,
    Copy,
    Delete,
    Details,
    Manager,
    MassDelete,
    Upload,
  },
  computed: {
    ...mapGetters(['modal'])
  },
  methods: {
    ...mapMutations(['closeModal']),
    handleKeyDown(event) {
      if (event.keyCode === 27) {
        event.preventDefault();
        this.closeModal();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>